(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/takeRight', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/takeRight'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.takeRight, global.convert);
    global.takeRight = mod.exports;
  }
})(this, function (exports, _takeRight2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.takeRight = undefined;

  var _takeRight3 = _interopRequireDefault(_takeRight2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Creates a slice of array with <code>n</code> elements taken from the end.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} [n=1] Number of elements to take from the end of the array.
   * @return {Object} Returns the updated object.
   * @example takeRight({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', 2) // => { nested: { prop: [3, 4] } }
   * @see {@link https://lodash.com/docs#takeRight|lodash.takeRight} for more information.
   * @since 0.3.0
   */
  var takeRight = (0, _convert.convert)(_takeRight3.default);
  exports.takeRight = takeRight;
  exports.default = takeRight;
});